:host {
  @apply flex flex-col bg-foreground-1;
}

:host([filter-hidden]) {
  @apply hidden;
}

@include disabled();

.container {
  @apply text-n1 text-color-2 m-0 flex flex-1 p-3 font-medium;
}

.heading {
  @apply p-0;
}

@include base-component();
